import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const buttonVariants = cva('inline-flex items-center w-fit justify-center whitespace-nowrap rounded-ads-md text-label-md-emphasis ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0', {
  variants: {
    variant: {
      Default: 'bg-primary text-primary-foreground transition-all hover:opacity-80',
      Destructive: 'bg-destructive/10 text-destructive hover:bg-destructive/20',
      Outline: 'bg-background text-foreground border border-solid border-border hover:bg-muted',
      Secondary: 'bg-muted text-foreground transition-all hover:opacity-80',
      Ghost: 'bg-transparent text-foreground hover:bg-muted',
      Link: 'bg-transparent text-foreground underline-offset-4 hover:underline'
    },
    size: {
      Small: 'h-6 px-2.5 py-0.5 gap-0.5 [&_svg]:size-4',
      Medium: 'h-8 px-3 py-1.5 gap-1 [&_svg]:size-5',
      Large: 'h-10 px-4 py-2.5 gap-1.5 [&_svg]:size-5'
    },
    iconOnly: {
      false: '',
      true: ''
    }
  },
  defaultVariants: {
    variant: 'Default',
    size: 'Large',
    iconOnly: false
  },
  compoundVariants: [{
    iconOnly: true,
    size: 'Large',
    className: 'p-2.5'
  }, {
    iconOnly: true,
    size: 'Medium',
    className: 'p-1.5'
  }, {
    iconOnly: true,
    size: 'Small',
    className: 'p-1'
  }]
});
const Button = /*#__PURE__*/React.forwardRef(({
  className,
  asChild = false,
  variant,
  size,
  disabled = false,
  icon = null,
  iconPosition = 'left',
  text = null,
  link = null,
  children,
  type = 'button',
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'button';
  const iconOnly = icon && !children && !text && !link;
  const content = children ?? (iconOnly ? icon : /*#__PURE__*/_jsxs(_Fragment, {
    children: [iconPosition === 'left' && icon, text ?? link, iconPosition === 'right' && icon]
  }));
  return /*#__PURE__*/_jsx(Comp, {
    className: cn(buttonVariants({
      variant,
      size,
      iconOnly,
      className
    })),
    ref: ref,
    disabled: disabled,
    type: type,
    ...props,
    children: content
  });
});
Button.displayName = 'Button';
export { Button, buttonVariants };